import React, { useEffect, useState } from "react";
import BuilderTable from "../../Layouts/BuilderTable";
import BuilderTabs from "../../Layouts/BuilderTabs";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import Navbar from "../../Layouts/Navbar/Navbar";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import InfoTooltip from "../../components/BuilderComponents/InfoTooltip";
import Button from "../../components/FormComponents/Button";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import { useVariableContext } from "../../context/VariableContext";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import { TryAgainMessage } from "../Screen/ScreenSection";
import "./Variable.css";
import { toastSuccess } from "../../utils/toastUtils";
import MultiRadio from "../../components/FormComponents/MultiRadio";
import Label from "../../components/FormComponents/Label";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import CopyToClipboard from "../../components/BuilderComponents/CopyToClipboard";
import { useModalContext } from "../../context/ModalContext";
import axiosInstance, { handleApiError } from "../../services/axiosService";
const initModalState = {
  isOpen: false,
  type: "",
  data: null
};
const initInputDataState = {
  key: "",
  value: "",
  type: "env",
  status: "custom"
};
const VariableSection = () => {
  const { fetchAllVariables, variableData, setVariableData } = useVariableContext();

  const { getUserConfirmation } = useModalContext();

  // const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(initModalState);
  const [isError, setIsError] = useState(false);
  const [searchQueries, setSearchQueries] = useState({});
  const [secretVariable, setSecretVariable] = useState(null);
  const closeModal = () => setIsModalOpen(initModalState);
  const openModal = (type, data = initInputDataState) => {
    setIsModalOpen({
      isOpen: true,
      type,
      data
    });
  };
  useEffect(() => {
    setIsError(false);
    try {
      fetchAllVariables();
    } catch (error) {
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteVariable = async (variable) => {
    try {
      const userConfirmed = await getUserConfirmation(`Are You Sure, You want to delete the variable ${variable.key}?`);
      if (!userConfirmed) return;
      const { message } = await axiosInstance.delete(`/appConfig/${variable.id}`);
      setVariableData((pre) => {
        if (variable.status === "custom") {
          return pre.filter((item) => item.id !== variable.id);
        } else {
          return pre.map((item) => (item.id === variable.id ? { ...item, value: "", type: "env" } : item));
        }
      });
      toastSuccess(message);
      closeModal();
    } catch (error) {
      handleApiError(error);
    }
  };

  const getSecretVariable = async (variableId) => {
    try {
      const { data } = await axiosInstance.get(`/appConfig/${variableId}`);
      setSecretVariable(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleToggleSecret = async (variable) => {
    if (secretVariable && secretVariable.id === variable.id) {
      setSecretVariable(null);
      return;
    }
    await getSecretVariable(variable.id);
  };

  const handleSearchChange = (category, value) => {
    setSearchQueries((prev) => ({ ...prev, [category]: value }));
  };

  const categorizeVariables = () => {
    const filtered = (query) =>
      variableData.filter((user) => user.key.toLowerCase().includes(query?.toLowerCase() || ""));

    return {
      SMS: filtered(searchQueries["SMS"]).filter((user) =>
        ["SMS", "MSG91"].some((keyword) => user.key.includes(keyword))
      ),
      Email: filtered(searchQueries["Email"]).filter((user) => user.key.includes("EMAIL")),
      Postgre: filtered(searchQueries["Postgre"]).filter((user) => user.key.includes("PG")),
      RDBMS: filtered(searchQueries["RDBMS"]).filter((user) => user.key.includes("RDBMS")),
      // Community: filtered(searchQueries["Community"]).filter((user) => user.key.includes("COMMUNITY")),
      Other: filtered(searchQueries["Other"]).filter(
        (user) =>
          ![
            "EMAIL",
            "SMS",
            "MSG91",
            "PG",
            "RDBMS"
            // "COMMUNITY"
          ].some((keyword) => user.key.includes(keyword))
      )
    };
  };

  const categories = categorizeVariables();

  const customColumns = [
    {
      header: "Key",
      render: (variable) => (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <span>{variable.key}</span>
          <InfoTooltip documentKey={`${variable.key}`} />
        </div>
      )
    },
    {
      header: "Value",
      render: (variable) => {
        const isSecret = variable.type === "secret";
        const isVisible = secretVariable && secretVariable.id === variable.id;
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <span
              style={{
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                maxWidth: "400px",
                display: "inline-block"
              }}
            >
              {isSecret ? (isVisible ? secretVariable?.value : "*******") : variable.value}
            </span>
            {isSecret && (
              <>
                <MaterialIcon
                  className="font_size_large"
                  style={{ cursor: "pointer", marginTop: "-2px", flexShrink: 0 }}
                  onClick={() => handleToggleSecret(variable)}
                  name={isVisible ? "visibility_off" : "visibility"}
                />
                {isVisible && <CopyToClipboard text={secretVariable.value} />}
              </>
            )}
          </div>
        );
      }
    },
    {
      header: "Type",
      render: (variable) => <>{variable.type}</>
    },
    {
      header: "Action",
      render: (variable) => (
        <div style={{ display: "flex", gap: "4px" }}>
          {variable.status === "custom" && <ButtonActionIcon type="delete" onClick={() => deleteVariable(variable)} />}
          <ButtonActionIcon type="edit" onClick={() => openModal("edit", variable)} />
        </div>
      )
    }
  ];

  const tabs = Object.keys(categories).map((category) => ({
    label: category,
    content: (
      <div className="variable_main_page">
        <div className="w_75" style={{ margin: "auto", paddingBottom: "48px" }}>
          <div
            className="variable_form_top"
            style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
          >
            <Input
              placeholder={`Search ${category}`}
              value={searchQueries[category] || ""}
              onChange={(e) => handleSearchChange(category, e.target.value)}
              containerStyle={{ width: "300px" }}
            />
            <Button onClick={() => openModal("create")}>+ Create</Button>
          </div>
          <BuilderTable
            columns={[]}
            data={categories[category]}
            customColumns={customColumns}
            columnStyles={{
              Action: { display: "flex", gap: "4px" }
            }}
            noDataMessage={`No ${category} Found`}
          />
        </div>
      </div>
    )
  }));

  const createVariable = async (data) => {
    try {
      const { data: apiData, message } = await axiosInstance.post("/appConfig", data);
      if (data.status === "custom") {
        setVariableData([{ ...data, id: apiData.id }, ...variableData]);
      } else {
        setVariableData((pre) => {
          return pre.map((item) => {
            if (item.key === data.key) {
              return { ...data, id: apiData.id };
            }
            return item;
          });
        });
      }
      closeModal();
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const updateVariable = async (data) => {
    try {
      const { message } = await axiosInstance.put(`/appConfig/${data.id}`, data);
      setVariableData(variableData.map((item) => (item.id === data.id ? data : item)));
      closeModal();
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  return (
    <>
      <section className="main_section">
        {isError ? (
          <TryAgainMessage retryFunction={fetchAllVariables} />
        ) : (
          <>
            <div className="d_flex">
              <HeaderModes />
              <PageInfoAndActionBar pagePath={`Variables`} pageName="variables" />
            </div>
            <div className="d_flex">
              <Navbar />
              <BuilderTabs tabs={tabs} containerClass="vertical-tab" tabsClass="tabs" />
            </div>
          </>
        )}
      </section>
      <BuilderModal isOpen={isModalOpen.isOpen} onClose={closeModal} modalName="Create Variable">
        <CreateVariable
          variable={isModalOpen.data}
          onCreate={createVariable}
          onUpdate={updateVariable}
          onDelete={deleteVariable}
        />
      </BuilderModal>
    </>
  );
};

const initErrorState = {
  key: "",
  value: "",
  type: ""
};
const smsProviderOptions = [{ id: "msg91", name: "msg91" }];

const allowGroupMessagingOptions = [
  { id: "true", name: "true" },
  { id: "false", name: "false" }
];
const typeOptions = [
  { id: "env", name: "ENV" },
  { id: "secret", name: "Secret" }
];
const CreateVariable = ({ variable, onCreate, onDelete, onUpdate }) => {
  const [inputData, setInputData] = useState(variable);
  const [errors, setErrors] = useState(initErrorState);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (name, value) => {
    setInputData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ""
    }));
  };

  const validateFields = () => {
    const newErrors = {};
    if (!inputData.key.trim()) newErrors.key = "Key is required";
    if (!inputData.type.trim()) newErrors.type = "Type is required";
    return newErrors;
  };

  const handleInsertVariable = async () => {
    setIsLoading(true);

    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsLoading(false);
      return;
    }

    try {
      const dataToSend = {
        ...inputData,
        key: inputData.key.toUpperCase()
      };

      if (inputData.id && !inputData.value && inputData.status === "default") {
        await onDelete(dataToSend);
      } else if (inputData.id) {
        await onUpdate(dataToSend);
      } else {
        await onCreate(dataToSend);
      }
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setIsLoading(false);
      setInputData(initInputDataState);
      setErrors(initErrorState);
    }
  };

  const renderAppropriateRenderer = () => {
    switch (inputData.key) {
      case "SMS_PROVIDER":
        return (
          <div className="builder_form">
            <SingleSelectBox
              selectedData={inputData.value}
              options={smsProviderOptions}
              onChange={(obj) => handleInputChange("value", obj.id)}
              placeholder="Enter value"
              error={errors.value}
            />
          </div>
        );

      case "DISABLE_ALL_SCREEN_ACCESS":
        // case "COMMUNITY_USERS_LOGIN":
        // case "COMMUNITY_USERS_SIGNUP":
        return (
          <div className="builder_form">
            <SingleSelectBox
              selectedData={inputData.value}
              options={allowGroupMessagingOptions}
              onChange={(obj) => handleInputChange("value", obj.id)}
              placeholder="Enter value"
              error={errors.value}
            />
          </div>
        );

      default:
        return (
          <Input
            name="value"
            placeholder="Enter value"
            value={inputData.value}
            onChange={(e) => handleInputChange("value", e.target.value)}
            error={errors.value}
          />
        );
    }
  };
  return (
    <div className="builder_form">
      <Input
        label="Enter Key"
        name="key"
        placeholder="Enter key (e.g., API_KEY, DATABASE_URL)"
        value={inputData.key}
        onChange={(e) => handleInputChange(e.target.name, e.target.value)}
        error={errors.key}
        disabled={inputData.status === "default"}
      />
      <Label>Enter Value</Label>
      {renderAppropriateRenderer()}
      <MultiRadio
        options={typeOptions}
        keyName="id"
        selectedValue={inputData.type}
        label={"Select Type"}
        onChange={(e) => handleInputChange("type", e.target.value || "")}
      />
      <Button
        onClick={handleInsertVariable}
        variant={inputData.id && !inputData.value && inputData.status === "default" ? "delete" : "primary"}
        isLoading={isLoading}
      >
        {inputData.id && !inputData.value && inputData.status === "default"
          ? "Delete"
          : inputData.id
            ? "Update"
            : "Create"}
      </Button>
    </div>
  );
};

export default VariableSection;
